/*jshint esversion: 6 */
/*jshint multistr: true */
//@prepros-prepend ../../lib/history/html4+html5/jquery.history.js

    $(function () {

        var rs24;

        var providerYT1         = 'youtube',
            providerYT2         = 'youtu.be',
            providerVimeo       = 'vimeo',
            providerCDN         = 'CDN',
            markers             = [25, 50, 75],
            playersMarkers      = [],
            videoInitialPlay    = false,
            windowWidth         = $(window).width();

        // returns vimeo, youtube, CDN
        var getVideoType = function(videoURL) {
            if (videoURL && (videoURL.includes(providerYT1) || videoURL.includes(providerYT2))) {
                return providerYT1;
            }

            if (videoURL && videoURL.includes(providerVimeo)) {
                return providerVimeo;
            }

            return providerCDN;
        };

        function eventToDataLayer(thisObject, eventType) {
            var eventName;

            if (thisObject.currentSrc()) {
                eventName = thisObject.currentSrc();
            } else {
                eventName = 'not set';
            }

            dataLayer.push({
                event: 'video',
                eventCategory: 'Video',
                eventAction: eventType,
                eventLabel: eventName
            });
        }

        function findObjectIndexById(haystack, key, needle) {
            for (var i = 0; i < haystack.length; i++) {
                if (haystack[i][key] == needle) {
                    return i;
                }
            }
            return null;
        }

        function applyVideoAnalytics(player) {
            // videojs on events: loadstart, sourceset, waiting, ended, seeking, play, firstplay, durationchange, fullscreenchange, error, loadedmetadaa, posterchange, textdata, ratechange timeupdate

            playersMarkers.push({
                id: player.id_,
                markers: []
            });

            player.on('play', function(e) {
                if (videoInitialPlay) { return; }
                videoInitialPlay = true;
                eventToDataLayer(this, 'Played video');
            });

            player.on('pause', function(e) {
                let remainingTime =  player.remainingTime();

                if (remainingTime != 0) {
                    eventToDataLayer(this, 'Paused video');
                }
            });

            player.on('ended', function(e) {
                eventToDataLayer(this, '100%');
            });

            player.on('error', function(e) {
                eventToDataLayer(this, 'Video error');
            });

            player.on('timeupdate', function(e) {
                var percentPlayed = Math.floor(player.currentTime() * 100 / player.duration());
                var playerMarkerID = player.id_;
                var playerMarkerIndex = findObjectIndexById(playersMarkers, 'id', playerMarkerID);
                if (markers.indexOf(percentPlayed) > -1 && playersMarkers[playerMarkerIndex].markers.indexOf(percentPlayed) == -1) {
                    playersMarkers[playerMarkerIndex].markers.push(percentPlayed);
                    eventToDataLayer(this, percentPlayed + '%');
                }
            });
        }

        function startSlider() {

            var startIndex = $('.gallery__slider_item.is_current').index();
            var historyEnabled = $('.js_royal').data('history');

            if( !historyEnabled ) { historyEnabled = false; }

            rs24 = $('.js_royal').royalSlider({

                addActiveClass: true,
                autoScaleSlider: false,
                autoHeight: false,

                arrowsNav: false,
                arrowsNavAutoHide: false,
                navigateByClick: false,
                fadeinLoadedSlide: true,

                imageScaleMode: 'fit-if-smaller',
                imageAlignCenter: true,
                imageScalePadding: 0,
                loop: false,
                loopRewind: false,

                controlNavigationSpacing: 0,
                controlNavigation: 'thumbnails',

                numImagesToPreload: 1,
                keyboardNavEnabled: true,
                usePreloader: true,
                startSlideId : startIndex,

                thumbs: {
                    // thumbnails options go gere
                    arrows: false,
                    autoCenter: false,
                    fitInViewport: false
                },

                deeplinking: {
                    // deep linking options
                    enabled: false,
                    // change: true, // using historyOptions
                    prefix: 'slider-'
                },

                historyOptions: {
                    enabled           : historyEnabled,
                    baseUri           : window.location.pathname.split('/multimedia/p')[0],
                    dataAttr          : {               // customize them when needed
                        uri             : 'history-uri',
                        title           : 'history-title',
                        data            : 'history-data'
                    },
                    title             : {
                        prefix          : '',
                        keepOriginal    : true
                    },
                    callbacks: {
                        afterPushState: function(pushData) {
                            // do something after the pushState action
                        },
                        stateChange   : function(state) {
                            // do something after the stateChange event
                        }
                    }
                },

                video: {
                    // video options go here
                    autoHideBlocks: true,
                    autoHideArrows: false
                }

            }).data('royalSlider');

            $('.no_royal').removeClass('no_royal');
            $('.royalSlider').css('visibility', 'visible');

            // if first element is video play it after slider is initialized

            if (rs24.currSlideId == 0 && rs24.currSlide.videoURL) {
                setTimeout(function() {
                    rs24.playVideo();
                }, 500);
            }

            rs24.ev.on('rsOnCreateVideoElement', function(e, url) {

                if (getVideoType(url) !== providerCDN) return;

                // url - path to video from data-rsVideo attribute
                // rs24.videoObj - jQuery object that holds video HTML code
                // rs24.videoObj must be IFRAME, VIDEO or EMBED element, or have class rsVideoObj

                rs24.videoObj = $(
                    '<video class="video video-js js_videoPlayer rsVideoObj" playsinline>Loading the player ...</video>'
                );

                // reset global flag used for applyVideoAnalytics function
                videoInitialPlay = false;

                if (windowWidth >= 1200) {

                    var prerollTag = 'https://pubads.g.doubleclick.net/gampad/ads?sz=504x338|620x380&iu=/18981092/Autostart_Video_PreRoll&impl=s&gdfp_req=1&env=vp&output=xml_vast2&unviewed_position_start=1&url=autostart.24sata.hr&description_url=[description_url]&correlator='+ new Date().getTime(),
                        disablePrerol =
                            $('body').data('bodyextrainfo') &&
                            $('body')
                                .data('bodyextrainfo')
                                .includes('no_preroll');

                    setTimeout(function() {
                        // must add timeout on play-> to play ads you need to play video first, and due to loading times for scripts you can see few miliseconds of video before it is actualy paused to play add
                        // https://github.com/googleads/videojs-ima/issues/167

                        var player = videojs(rs24.videoObj[0], {
                                controls: true,
                                autoplay: false,
                                preload: 'auto',
                                prerollTimeout: 500,
                                timeout: 5000
                            }),
                            playerID = player.id();

                        player.src({ type: 'video/mp4', src: url });

                        if (disablePrerol) {
                            prerollTag = '';
                        } else {
                            var options = {
                                id: playerID,
                                adTagUrl: prerollTag,
                                adLabel: 'Reklama'
                            };

                            player.ima(options);
                        }

                        var shareOptions = {
                            socials: ['fbFeed', 'messenger', 'tw', 'viber', 'email'],

                            url: window.location.href,
                            image: player.poster(),

                            // required for Facebook and Messenger
                            fbAppId: '412582762167121',
                            // optional for Facebook
                            redirectUri: window.location.href + '#close'
                        };

                        player.share(shareOptions);

                        player.muted(true);
                        player.volume(0);

                        // we do not have before play func
                        applyVideoAnalytics(player);
                        player.play();
                    }, 50);

                } else {

                    var file_url = url.split('#')[0];
                    var poster_url = url.split('#')[1];

                    setTimeout(function() {
                        var player = videojs(rs24.videoObj[0], { 'controls': true, 'autoplay': false, 'preload': 'auto', 'prerollTimeout': 500, 'timeout': 5000}),
                            playerID = player.id();

                        player.src({ type: 'video/mp4', src: file_url });

                        var shareOptions = {
                            socials: ['fbFeed', 'messenger', 'tw', 'viber', 'email'],

                            url: window.location.href,
                            image: player.poster(),

                            // required for Facebook and Messenger
                            fbAppId: '412582762167121',
                            // optional for Facebook
                            redirectUri: window.location.href + '#close',

                        }

                        player.share(shareOptions);

                        player.muted(true);
                        player.volume(0);

                        // we do not have before play func
                        applyVideoAnalytics(player);
                        player.play();

                        // tap on mobile devices to toggle play/pause
                        player.on('touchstart', function(e) {
                            if (e.target.nodeName === 'VIDEO') {
                                if (player.paused()) {
                                    this.play();
                                } else {
                                    this.pause();
                                }
                            }
                        });

                        player.on('seeking', function(e) {
                            if(player.currentTime() === 0) {
                                player.addClass('vjs-looping');
                            }
                        });

                        player.on('playing', function(e) {
                            if(player.currentTime() === 0) {
                                player.removeClass('vjs-looping');
                            }
                        });

                    }, 200);
                }
            });

            rs24.ev.on('rsOnDestroyVideoElement', function(e) {
                // rs24.videoObj - jQuery object that holds video HTML code
            });

            setTimeout(function() {
                $('.js_royal').royalSlider('updateSliderSize', true);
                setButtons();
            }, 200);

            function generateMarkup ( title, url, eventLabel ) {

                siteTITLE = title;
                siteTITLEencoded = encodeURIComponent(title);

                siteURL = url;
                siteURLencoded = encodeURIComponent(url);

                var markup = '\
                    <a href="https://www.facebook.com/sharer/sharer.php?u=http%3A%2F%2F' + siteURL + '" target="_blank" class="btn btn--face2 mh10 mv10" data-eventcategory="Shareanje" data-eventaction="Facebook" data-eventlabel="' + eventLabel + '">\
                        <span class="icon-facebook"></span>\
                    </a>\
                    \
                    <a href="https://twitter.com/intent/tweet?counturl=http%3A%2F%2F' + siteURLencoded + '&amp;text=' + siteTITLEencoded + '&amp;url=http%3A%2F%2F' + siteURLencoded + '&amp;via=24sata_HR" target="_blank" class="btn btn--twit2 mh10 mv10" data-eventcategory="Shareanje" data-eventaction="Twitter" data-eventlabel="' + eventLabel + '">\
                        <span class="icon-twitter"></span>\
                    </a>\
                    \
                    <a href="https://plus.google.com/share?url=http%3A%2F%2F' + siteURLencoded + '" target="_blank" class="btn btn--goog2 mh10 mv10" data-eventcategory="Shareanje" data-eventaction="Googleplus" data-eventlabel="' + eventLabel + '">\
                        <span class="icon-googleplus"></span>\
                    </a>';

                return markup;
            }

            function setButtons () {

                var currentSlide = rs24.currSlideId,
                    pageUrlPath = '?page=',
                    $galleryControls = $('.js_galleryControllers'),
                    absoluteLink = $galleryControls.data('absolute-url').split(pageUrlPath)[0],
                    $prevLink =  $galleryControls.find('.js_galleryPrev'),
                    $nextLink = $galleryControls.find('.js_galleryNext'),
                    pagePrev,
                    pageNext;

                if (currentSlide === 0) {
                    pagePrev = currentSlide + 1;
                    pageNext = currentSlide + 2;
                } else if (currentSlide === rs24.numSlides - 1) {
                    pagePrev = currentSlide;
                    pageNext = currentSlide + 1;
                } else {
                    pagePrev = currentSlide;
                    pageNext = currentSlide + 2;
                }

                $prevLink.attr('href', absoluteLink + pageUrlPath + pagePrev);
                $nextLink.attr('href', absoluteLink + pageUrlPath + pageNext);

                if ( currentSlide == ( rs24.numSlides - 1 ) ) {
                    $('#slider-next').addClass('is_hidden');
                } else {
                    $('#slider-next').removeClass('is_hidden');
                }

                var $galleryShare = $('.js_galleryShare');

                if ($galleryShare.length) {

                    var galleryTitle  = $galleryShare.data('gallery_title');
                    var galleryUrl    = $galleryShare.data('gallery_url').split('page=')[0] + 'page=';
                    var galleryEvent  = $galleryShare.data('gallery_event');

                    $galleryShare.html( generateMarkup ( galleryTitle, galleryUrl + (currentSlide + 1), galleryEvent ));
                }
            }

            setButtons();

            rs24.ev.on('rsAfterSlideChange', function(event) {
                setButtons();
                window.initGalleryDfp();

                if (window.dm && typeof window.dm.AjaxEvent === 'function') {
                    dm.AjaxEvent('pageview', null, dm.dotmetricsDefaultId);
                }
            });

            $('.gallery').on('click', '#slider-prev', function(e) {
                e.preventDefault();
                rs24.prev();
            });

            $('.gallery').on('click', '#slider-next', function(e) {
                e.preventDefault();
                rs24.next();
            });
        }

        $(window).resize( function(){

            var height = $(window).height(),
                width  = $(window).width(),
                orientation, tmp_orientation;

            tmp_orientation = '';

            if( width > height ) {
                orientation = 'Landscape';
            } else {
                orientation = 'Portrait';
            }

            if( orientation != tmp_orientation ) {
                tmp_orientation = orientation;
            }
        });

        function initInlineGallery (){

            // if you use mutliple sliders, you need to call RoyalSlider destroy() method when box
            // closes to destroy it's data.
            var win = $(window),
                w,
                currRs;

            if( $('.js_openBoxButton').length ) {

                var articleURL = document.location.pathname;

                $('.js_openBoxButton').magnificPopup({

                    closeMarkup: '<button title="%title%" type="button" class="gallery__close mfp-close"></button>',
                    tClose: 'Zatvori galeriju (Esc)',

                    type: 'ajax',
                    ajax: {
                        settings: {
                            headers: { "X-Request-Content": "Snippet" }
                        }
                    },
                    closeOnBgClick: true,
                    callbacks: {

                        ajaxContentAdded: function() {
                            startSlider ();
                        },

                        close: function() {
                            // destroy the slider to avoid memory leaks
                            rs24.destroy();
                            History.pushState(null, null, articleURL);
                        }
                    }
                });
            }

            if( $('.js_autoOpenBoxButton' ).length){

                var autoOpenBoxButton = $('.js_autoOpenBoxButton');

                var galleryPath = autoOpenBoxButton.attr('href').split('/galerija')[0] + '/galerija-'+ autoOpenBoxButton.data('gallery') +'/?page='+ autoOpenBoxButton.data('image');

                autoOpenBoxButton.attr('href', galleryPath);

                autoOpenBoxButton.trigger('click');
            }

            if( $('.js_royal').length ) {
                startSlider ();

                $(document).bind('keydown', function(e) {

                    if (e.which == 27) {

                        console.log('ESC (close)');

                        setTimeout(function(){
                            document.location.href = $('.js_closeGallery').attr('href');
                        }, 300);
                    }
                });
            }
        }

        function initReadUrl (){

            var getUrlParameter = function getUrlParameter(sParam) {

                var sPageURL = decodeURIComponent(window.location.search.substring(1)),
                    sURLVariables = sPageURL.split('&'),
                    sParameterName;

                for (var i = 0; i < sURLVariables.length; i++) {
                    sParameterName = sURLVariables[i].split('=');

                    if (sParameterName[0] === sParam) {
                        return sParameterName[1] === undefined ? true : sParameterName[1];
                    }
                }
            };

            var $string = getUrlParameter('initialarticle');

            if ( $string !== undefined && $string !== null ) {

                $('.js_closeGallery').attr('href', $string);

            }
        }

        initInlineGallery();
        initReadUrl();

    });
